import React from 'react';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelExport = ({ applicants, t }) => {
    // Check if applicants or rows are undefined or null
    if (!applicants || !applicants.length) {
        return null; // Or show a loading message or something appropriate
    }

    const exportToExcel = () => {
        // Transform applicants into a format suitable for the Excel file
        const data = applicants.map((applicant) => ({
            Name: applicant.firstname || '',
            Gender: applicant.gender || '',
            Education: applicant.education || '',
            Mobile: applicant.mobile || '',
            Attendance: applicant.attendence === '1' ? 'Present' : applicant.attendence === '0' ? 'Absent' : '',
        }));

        // Create a worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Candidates');

        // Write the workbook to a buffer and create a file
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const file = new Blob([excelBuffer], { type: 'application/octet-stream' });

        // Trigger the download
        saveAs(file, 'Selected_candidates.xlsx');
    };

    return (
        <div className="row pl-3 pr-3">
            {applicants.length ? (
                <>
                    <h6 className="mr-3">
                        {t('counsellingProvider.session_name', { param: 'react' })}: <b>{applicants[0].session_name}</b>
                    </h6>
                    <h6 className="mr-3">
                        {t('counsellingProvider.seat', { param: 'react' })}: <b>{applicants[0].seat}</b>
                    </h6>
                    <h6 className="mr-3">
                        {t('counsellingProvider.sessionMode', { param: 'react' })}: <b>{applicants[0].mode}</b>
                    </h6>
                    <h6 className="mr-3">
                        {/* Button to trigger Excel download */}
                        <button aria-label="Download Excel" className="btn btn-primary btn-primary2" onClick={exportToExcel}>
                            {t('counsellingProvider.downloadExcel', { param: 'react' })}
                        </button>
                    </h6>
                </>
            ) : null}
        </div>
    );
};

export default ExcelExport;
